/**
 * Fleet API module — typed fetch functions for the Fleet dashboard.
 */

import { apiFetch, createEventSource } from './client.js'
import type { FleetDashboard, FleetSSEEvent } from '../types/api.js'

/** Fetch the full fleet dashboard in one call (v2). */
export const fetchFleetDashboard = (): Promise<FleetDashboard> =>
  apiFetch<FleetDashboard>('/api/v2/fleet/dashboard')

// ─── SSE Stream ─────────────────────────────────────────────────────────────

/** Open fleet live stream. Returns EventSource — caller manages lifecycle. */
export function openFleetStream(
  onEvent: (event: FleetSSEEvent) => void,
  onError?: (err: Event) => void,
): EventSource {
  const es = createEventSource('/api/v2/fleet/stream')

  const eventTypes = [
    'run_started',
    'run_completed',
    'run_failed',
    'stage_changed',
    'iteration_changed',
  ] as const

  for (const type of eventTypes) {
    es.addEventListener(type, (e: MessageEvent) => {
      try {
        // SL-TS02 accepted: SSE data from our own backend
        const parsed = JSON.parse(e.data) as FleetSSEEvent
        onEvent(parsed)
      } catch {
        // Malformed SSE frame — skip, do not close stream
      }
    })
  }

  if (onError) {
    es.addEventListener('error', onError)
  }

  return es
}
